module.exports = __webpack_public_path__ + "static/media/nosotros03M.2378a057.jpg";